enum CarType {
  Van = 'van',
  PersonalCar = 'personalCar',
}

export default CarType;
